import { Text, Stack, HStack, Box, Flex } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../../utils/colors";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsMobile = (
  slug,
  dispatch,
  translate,
  handleSortChange,
  updateProfessionStatus,
  setShowDeleteConfirmation,
  setProfessionId,
  setProfessionName,
  setInEmployees,
  openEditSidePanelModal,
  hasAccessToEdit
) => {
  return [
    {
      Header: () => (
        <Box onClick={() => handleSortChange("name")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("service.columnName")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "name",
      // width: 420,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { name } = row.original;

        return (
          <HStack gap={2}>
            <Stack gap={0} overflow="hidden">
              <Text
                fontSize="sm"
                color={textPrimary}
                fontWeight="600"
                textAlign="left"
                isTruncated // This will add ellipsis
                maxW="78%"
              >
                {name}
              </Text>
            </Stack>
          </HStack>
        );
      },
    },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("status")} w="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "status",
      preventRowClick: false,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { status, _id } = row.original;

        const handleUpdateStatus = (newStatus) => {
          dispatch(updateProfessionStatus(slug, _id, newStatus));
        };

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNew
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="serviceNew"
              isUnclickable
              p="0 2.5rem"
            />
          </HStack>
        );
      },
    },
  ];
};
